import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Styles from '../Style/Common.module.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import parse from 'html-react-parser';
import constants from '../../services/constants';
import { getWhyChooseusAPI } from "../../services/routes.services";
import Loader from "../Common/PageLoader/LoadingSpinner";
import CustomButtonGroup from "../Common/CustomButtonGroup";
const WhyChooseUs = (props)=>{
  const [loading, setLoading] = useState(true);
  const [whyChooseus, setWhyChooseus] = useState([]); 
  const valueSlide = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 580 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 580, min: 0 },
      items: 1
    }
  };
  useEffect(() => {
      Promise.all([
          getWhyChooseusAPI('services'),
      ]).then(([whyChooseusRes, trustRes, allServicesRes, CFTworkRes ]) => {
          setWhyChooseus(whyChooseusRes?.data?.whychooseus[0]);
          setLoading(false);
      }).catch(error => {
          console.log(error);
          setLoading(false);
      });
  }, []);
  console.log(whyChooseus)
  if (loading) {
    return <Loader />;
  }
    return(
        <div className={'valuesSection ' + Styles.valueSec + " " + Styles.whuchooseSec}>
          <Container fluid>
            <Row>
              <Col>
                <div className={Styles.valuesContainer}>
                  <h2>Why Choose TQ Cert Services? </h2>
                  <div className={'navBtn ' + Styles.valueOwl}>
                    <Carousel
                        autoPlaySpeed={2000}
                        transitionDuration={500}
                        responsive={valueSlide}
                        autoPlay={true}
                        infinite={true}
                        arrows={false}
                        customButtonGroup={<CustomButtonGroup />}
                        renderButtonGroupOutside={true}
                        containerClass="whyUsOwl"
                    >
                      {whyChooseus?.fields.length > 0 && whyChooseus?.fields?.map((item, index)=>{
                        return(
                          <div className={Styles.valueSlide} key={index}>
                            <figure>
                              <img src={`${constants.Image_BASE_URL}${item?.image[0]?.fileName}`} />
                            </figure>
                            <h4>{item?.title}</h4>
                            {parse(`${item?.description}`)}
                          </div>
                        )
                      })}
                    </Carousel>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }

export default WhyChooseUs;